import { all, call, put, takeLatest, select } from "redux-saga/effects"
import API from "../../helpers/sagaApi/sagaApi"
import Actions, { SagaCartTypes } from "./sagaCartRedux"
import AppConfig from "../../configs/AppConfig"
import { confirmClearCart } from "../../helpers/utility"
import reducers from "../reducers"

export function* getBookingDate() {
  const token = yield select((state: typeof reducers) => {
    return state.SagaCart.bookingDate
  })
  return token
}

export default function* rootSaga() {
  yield all([])
}



// WEBPACK FOOTER //
// ./src/redux/sagaCart/sagaCartSaga.ts